module.exports = __webpack_public_path__ + "static/media/question-button-press-a.96916e22.png";